export default {
    formatTime(datestr, format) { //时间戳转日期 如：(date,"Y-M-D)或(date,"Y-M-D h:m:s)"
        function formatNumber(n) {
            n = n.toString();
            return n[1] ? n : "0" + n;
        }

        let formateArr = ["Y", "M", "D", "h", "m", "s"];
        let returnArr = [];
        let date = new Date(datestr);
        returnArr.push(date.getFullYear());
        returnArr.push(formatNumber(date.getMonth() + 1));
        returnArr.push(formatNumber(date.getDate()));

        returnArr.push(formatNumber(date.getHours()));
        returnArr.push(formatNumber(date.getMinutes()));
        returnArr.push(formatNumber(date.getSeconds()));

        for (let i in returnArr) {
            format = format.replace(formateArr[i], returnArr[i]);
        }
        return format;
    },
};


// WEBPACK FOOTER //
// ./src/utils/common.js